import { useAsyncValue } from '../../hooks';

const DynamicImage = ({ src, ...props }) => {
  const load = () =>
    new Promise((onload, onerror) =>
      Object.assign(new Image(), { onload, onerror, src })
    );

  useAsyncValue(load, src);
  return <img {...{ src, ...props }} />;
};
export default DynamicImage;
